import React from 'react';

type ModalContextType =
  | {
      shouldCloseOnEsc?: boolean;
    }
  | undefined;

const ModalContext = React.createContext<ModalContextType>(undefined);

export default ModalContext;
